export function MessageRequest(type, response, message, show, error = false) {
  show(true);
  const status = response?.status ?? 500;
  const errorMessage = error ? error : 'Ocorreu um erro inesperado!';

  return status === 200 ?
    message(`${type} com sucesso!`) :
    message(errorMessage);
}
